import React from 'react'
import { connect } from 'react-redux'
import 'react-datepicker/dist/react-datepicker.min.css'
import { Checkbox } from 'semantic-ui-react'

const CheckBoxInput = (props) => {
    const { label, require,input, disabled, style, meta: { touched, error } } = props
    const isChecked = (value='') =>{
      if(typeof(value) === 'boolean'){
        return value
      }else if(typeof(value) === 'string'){
        if(value.toLowerCase() === 'true'){
          return true
        }
      }
      return false
    }

    return (
        <div className='fieldRow lg:mt-1' style={{...style}}>
        <div className='fieldInput'>
          <Checkbox  
            {...input}
            value=''
            checked={
              isChecked(input.value)
            }
            label={
              <label>
                {label}
                {require ? <span className='require'>*</span> : null}
                {touched && error ? <span className='error'>{error}</span> : null}
              </label>
            }
            disabled={disabled === false}
            onChange={(e, { checked }) => input.onChange(checked)} />
        </div>
      </div>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckBoxInput)

